import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useEditable } from 'use-editable';

import { updatePageModule } from '../../../store/actions/admin/create-event/session';
import { EventsState } from '../../../store/types';
import { GetDefaultTranslateString } from '../../../store/utils/create-event';
import { PageModule, TranslateString } from '../../../types/working-model';
import { updateTranslateKey } from '../../../utils/utils';

export type HeadingTypes = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface EditableCustomTitleProps {
	moduleTitle: string;
	element: HeadingTypes;
	pageModule: PageModule;
	content: any;
}

const EditableCustomTitle: React.FC<EditableCustomTitleProps> = ({
	moduleTitle = '',
	element,
	content,
	pageModule,
}) => {
	const ref = useRef<HTMLHeadingElement | null>(null);
	const dispatch = useDispatch();
	const { workingSession } = useSelector(
		(state: EventsState) => state.CreateSessionReducer
	);
	const { lang } = useParams<{ lang: string }>();

	useEditable(ref, setCustomHeadingTitle);

	function setCustomHeadingTitle(text: string) {
		const translateStringObj: TranslateString =
			content?.custom_heading || GetDefaultTranslateString();

		if (!text?.trim()?.length) {
			translateStringObj.base = moduleTitle || '';
		}

		dispatch(
			updatePageModule({
				...pageModule,
				content: {
					...(content || {}),
					custom_heading: updateTranslateKey({
						translateString: translateStringObj,
						input: text,
						baseLanguage: workingSession!.default_language,
						language: lang
					}),
				},
			})
		);
	}

	return React.createElement(
		element,
		{
			ref,
		},
		content?.custom_heading?.base
			? content?.custom_heading[lang]
			: moduleTitle
	);
};

export default EditableCustomTitle;
